import React from 'react';
import { styled } from '@mui/material/styles';
import { Switch as MuiSwitch } from '@mui/material';
import { PSYLARIS_SLIGHTLY_LIGHTER_GREY } from '../../../utils/Colors';
import PsylarisIconColor from '../../../assets/circles_color.png';
import PsylarisIconGrey from '../../../assets/circles_grey.png';
import PsylarisPersonColor from '../../../assets/person_color.png';
import PsylarisPersonGrey from '../../../assets/person_grey.png';
import { useTranslation } from 'react-i18next';

// rest of your styled labels/columns exactly as before
const GrowLabelLeft = styled('label')({ justifyItems: 'end', color: 'black' });
const GrowLabelRight = styled('label')({ justifyItems: 'start', color: 'black' });
const LeftColumn = styled('div')({
  display: 'grid',
  justifyItems: 'center',
  marginLeft: '10px',
  flexGrow: 1,
});
const Column = styled('div')({
  display: 'grid',
  justifyItems: 'center',
  marginRight: '10px',
  flexGrow: 1,
});

const StyledSwitch = styled(MuiSwitch)(() => ({
  width: 47,
  height: 22,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(24px)',
      '& + .MuiSwitch-track': {
        borderColor: PSYLARIS_SLIGHTLY_LIGHTER_GREY,
        opacity: 1,
        backgroundColor: '#9CA3AF',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    color: 'white',
    width: 18,
    height: 18,
  },
  '& .MuiSwitch-track': {
    borderRadius: 14,
    backgroundColor: '#9CA3AF',
    border: `1px solid ${PSYLARIS_SLIGHTLY_LIGHTER_GREY}`,
    opacity: 1,
  },
}));

export default function Switch(props: {
  isVideoEnabled: boolean;
  name: string;
  onToggle: (checked: boolean) => void;
  onRight: (checked: boolean) => void;
  isDisabled: boolean;
}) {
  const { isVideoEnabled, name, onToggle, onRight, isDisabled } = props;
  const { t } = useTranslation();

  const leftIcon = !isVideoEnabled ? PsylarisIconColor : PsylarisIconGrey;
  const rightIcon = isVideoEnabled ? PsylarisPersonColor : PsylarisPersonGrey;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    onToggle(checked);
    onRight(checked);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', height: 75, gap: 5 }}>
      <LeftColumn>
        <img src={leftIcon} alt="" />
        <GrowLabelLeft>{t('task')}</GrowLabelLeft>
      </LeftColumn>

      <StyledSwitch name={name} checked={isVideoEnabled} onChange={handleChange} disabled={isDisabled} disableRipple />

      <Column>
        <img src={rightIcon} alt="" />
        <GrowLabelRight>{t('Video')}</GrowLabelRight>
      </Column>
    </div>
  );
}
